import { Theme } from '@material-ui/core';

export interface LogoProps {
  applyTheme?: boolean;
  fullWidth?: boolean;
  width?: number | string;
  height?: number | string;
  maxWidth?: number | string;
  fillColor?: string;
}

export interface SelectiveLogoProps extends LogoProps {
  isOpen: boolean;
}

export const getFillColor = (theme: Theme, applyTheme: boolean): string => {
  // TRATON Blue 800 in light mode, TRATON Warm Grey 50 in dark mode.
  if (applyTheme) return theme.palette.type === 'light' ? '#004852' : '#F9F7F2';
  return '#D6D4C9';
};
